import { render } from "./categories-table.vue?vue&type=template&id=7246432f"
import script from "./categories-table.vue?vue&type=script&lang=js"
export * from "./categories-table.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__